(function () {
  if (window.__pjSetCartInit) return;
  window.__pjSetCartInit = true;

  var STYLE_ID = 'pj-upcart-group-style';
  var applying = false;
  var queued = false;
  var cartBound = false;
  var settleTimer = 0;

  var CSS = [
    '.upcart-item-property.is-pj-hidden-prop{display:none!important}',
    '.upcart-product-item.is-pj-grouped-source{display:none!important}',
    '.PjUpcartGroup{box-sizing:border-box;width:100%;margin:0 0 12px;padding:6px 10px 4px;border:1px solid #dce3ec;border-radius:8px;background:#fff;color:#2f343b;font-family:var(--text-font-family),Archivo,sans-serif}',
    '.PjUpcartGroup__Head{display:flex;align-items:center;justify-content:space-between;gap:8px;padding:4px 0}',
    '.PjUpcartGroup__Title{margin:0;font-family:var(--heading-font-family),Archivo,sans-serif;font-size:14px;font-weight:700;line-height:1.3;color:#2f343b}',
    '.PjUpcartGroup__Tag{display:inline-block;padding:4px 7px;background:var(--product-sale-price-color,#b0352f);color:#fff;font-size:11.5px;font-weight:900;line-height:1.2;letter-spacing:.01em;text-transform:uppercase;white-space:nowrap}',
    '.PjUpcartLine{display:flex;align-items:flex-start;gap:9px;padding:8px 0;border-bottom:1px solid #dce3ec}',
    '.PjUpcartLine:last-child{border-bottom:0}',
    '.PjUpcartLine__img{width:48px;height:48px;min-width:48px;object-fit:cover;border-radius:4px;background:#edf1f6}',
    '.PjUpcartLine__text{flex:1;min-width:0}',
    '.PjUpcartLine__title{margin:0;font-size:12px;font-weight:700;line-height:1.3;color:#2f343b}',
    '.PjUpcartLine__size{margin:2px 0 0;font-size:11.5px;font-weight:400;line-height:1.3;color:#5b6470}',
    '.PjUpcartLine__remove{display:inline-block;margin:2px 0 0;padding:6px 0;border:0;background:transparent;color:#2f343b;font:inherit;font-size:11.5px;font-weight:600;line-height:1.3;text-decoration:underline;cursor:pointer}',
    '.PjUpcartLine__price{margin-left:auto;text-align:right;white-space:nowrap}',
    '.PjUpcartLine__price .is-now{display:block;font-size:12.5px;font-weight:700;line-height:1.3;color:var(--product-sale-price-color,#b0352f)}',
    '.PjUpcartLine__price .is-now--full{color:#2f343b}',
    '.PjUpcartLine__price .is-was{display:block;font-size:11.5px;font-weight:400;line-height:1.3;color:#5b6470;text-decoration:line-through}'
  ].join('');

  function shadowRoot() {
    var host = document.getElementById('upCart');
    return host && host.shadowRoot ? host.shadowRoot : null;
  }

  function parseMoney(text) {
    if (!text) return null;
    var cleaned = String(text).replace(/[^0-9.,]/g, '');
    if (!cleaned) return null;
    var lastComma = cleaned.lastIndexOf(',');
    var lastDot = cleaned.lastIndexOf('.');
    if (lastComma > lastDot) cleaned = cleaned.replace(/\./g, '').replace(',', '.');
    else cleaned = cleaned.replace(/,/g, '');
    var amount = parseFloat(cleaned);
    if (isNaN(amount)) return null;
    return Math.round(amount * 100);
  }

  function optionValue(item, name) {
    var node = item.querySelector('[data-upcart-item-option-category="' + name + '"]');
    return node ? node.getAttribute('data-upcart-item-option-value') || '' : '';
  }

  function properties(item) {
    var props = {};
    var nodes = item.querySelectorAll('.upcart-item-property');
    for (var i = 0; i < nodes.length; i++) {
      var strong = nodes[i].querySelector('strong');
      var span = nodes[i].querySelector('span');
      if (!strong || !span) continue;
      props[strong.textContent.replace(':', '').trim()] = span.textContent.trim();
    }
    return props;
  }

  function readItem(item) {
    var props = properties(item);
    var priceNode = item.querySelector('.upcart-item-price');
    var compareNode = item.querySelector('.upcart-item-compare-price');
    var titleNode = item.querySelector('.upcart-product-title-link');
    var image = item.querySelector('img');
    var qtyNode = item.querySelector('.upcart-product-quantity-input');
    var qty = qtyNode ? parseInt(qtyNode.value, 10) : 1;
    if (!qty || qty < 1) qty = 1;
    return {
      el: item,
      id: item.id || '',
      setId: props._set || '',
      piece: props._piece || '',
      color: optionValue(item, 'Color') || optionValue(item, 'Colour'),
      size: optionValue(item, 'Size'),
      title: titleNode ? titleNode.textContent.trim() : '',
      image: image ? image.getAttribute('src') : '',
      alt: image ? image.getAttribute('alt') || '' : '',
      priceText: priceNode ? priceNode.textContent.trim() : '',
      compareText: compareNode ? compareNode.textContent.trim() : '',
      price: parseMoney(priceNode && priceNode.textContent),
      compare: parseMoney(compareNode && compareNode.textContent),
      qty: qty
    };
  }

  function pieceRank(piece) {
    if (piece === 'dog') return 0;
    if (piece === 'top') return 1;
    if (piece === 'pants') return 2;
    return 3;
  }

  function hideInternalProperties(root) {
    var nodes = root.querySelectorAll('.upcart-item-property');
    for (var i = 0; i < nodes.length; i++) {
      var strong = nodes[i].querySelector('strong');
      var key = strong ? strong.textContent.trim() : '';
      if (key.charAt(0) === '_') nodes[i].classList.add('is-pj-hidden-prop');
    }
  }

  function propertiesHidden(root) {
    var nodes = root.querySelectorAll('.upcart-item-property');
    for (var i = 0; i < nodes.length; i++) {
      var strong = nodes[i].querySelector('strong');
      var key = strong ? strong.textContent.trim() : '';
      if (key.charAt(0) === '_' && !nodes[i].classList.contains('is-pj-hidden-prop')) return false;
    }
    return true;
  }

  function groupSets(items) {
    var order = [];
    var buckets = {};
    items.forEach(function (item) {
      if (!item.setId) return;
      if (!buckets[item.setId]) {
        buckets[item.setId] = [];
        order.push(item.setId);
      }
      buckets[item.setId].push(item);
    });
    return order.map(function (id) {
      var lines = buckets[id].slice().sort(function (a, b) {
        return pieceRank(a.piece) - pieceRank(b.piece);
      });
      return { id: id, lines: lines };
    }).filter(function (group) {
      return group.lines.length > 1;
    });
  }

  function savePercent(lines) {
    var sumPrice = 0;
    var sumCompare = 0;
    for (var i = 0; i < lines.length; i++) {
      var line = lines[i];
      if (line.price == null || line.compare == null || line.compare <= line.price) return null;
      sumPrice += line.price * line.qty;
      sumCompare += line.compare * line.qty;
    }
    if (sumCompare <= sumPrice) return null;
    return Math.floor(((sumCompare - sumPrice) / sumCompare) * 100);
  }

  function sizeLabel(line) {
    if (!line.size) return '';
    if (line.piece === 'dog') return 'Dog size: ' + line.size;
    return 'Your size: ' + line.size;
  }

  function buildLine(line) {
    var row = document.createElement('div');
    row.className = 'PjUpcartLine';
    row.setAttribute('data-line', line.id + ':' + line.priceText + ':' + line.qty);

    var image = document.createElement('img');
    image.className = 'PjUpcartLine__img';
    image.alt = '';
    if (line.image) image.src = line.image;

    var text = document.createElement('div');
    text.className = 'PjUpcartLine__text';

    var title = document.createElement('p');
    title.className = 'PjUpcartLine__title';
    title.textContent = line.color ? line.title + ' – ' + line.color : line.title;

    var size = document.createElement('p');
    size.className = 'PjUpcartLine__size';
    size.textContent = sizeLabel(line);
    if (!size.textContent) size.hidden = true;

    var remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'PjUpcartLine__remove';
    remove.textContent = 'Remove';
    remove.addEventListener('click', function () {
      var trash = line.el.querySelector('.styles_TrashButton__deleteButton__');
      if (trash) trash.click();
    });

    text.appendChild(title);
    text.appendChild(size);
    text.appendChild(remove);

    var price = document.createElement('div');
    price.className = 'PjUpcartLine__price';
    var now = document.createElement('span');
    var onSale = line.compare != null && line.price != null && line.compare > line.price;
    now.className = onSale ? 'is-now' : 'is-now is-now--full';
    now.textContent = line.priceText;
    price.appendChild(now);
    if (onSale) {
      var was = document.createElement('span');
      was.className = 'is-was';
      was.textContent = line.compareText;
      price.appendChild(was);
    }

    row.appendChild(image);
    row.appendChild(text);
    row.appendChild(price);
    return row;
  }

  function buildGroup(group) {
    var card = document.createElement('div');
    card.className = 'PjUpcartGroup';
    card.setAttribute('data-pj-set', group.id);

    var head = document.createElement('div');
    head.className = 'PjUpcartGroup__Head';
    var title = document.createElement('p');
    title.className = 'PjUpcartGroup__Title';
    title.textContent = 'Matching set';
    head.appendChild(title);

    var pct = savePercent(group.lines);
    if (pct != null && pct > 0) {
      var tag = document.createElement('span');
      tag.className = 'PjUpcartGroup__Tag';
      tag.textContent = 'SAVE ' + pct + '%';
      head.appendChild(tag);
    }

    card.appendChild(head);
    group.lines.forEach(function (line) {
      card.appendChild(buildLine(line));
      line.el.classList.add('is-pj-grouped-source');
    });
    return card;
  }

  function ensureStyle(root) {
    if (root.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = CSS;
    root.appendChild(style);
  }

  function renderedKey(section) {
    return Array.prototype.map.call(section.querySelectorAll('.PjUpcartGroup'), function (card) {
      var lines = Array.prototype.map.call(card.querySelectorAll('.PjUpcartLine'), function (line) {
        return line.getAttribute('data-line');
      }).join(',');
      return card.getAttribute('data-pj-set') + '=' + lines;
    }).join(';');
  }

  function desiredKey(groups) {
    return groups.map(function (group) {
      return group.id + '=' + group.lines.map(function (line) {
        return line.id + ':' + line.priceText + ':' + line.qty;
      }).join(',');
    }).join(';');
  }

  function sourcesMatch(items, groups) {
    var grouped = {};
    groups.forEach(function (group) {
      group.lines.forEach(function (line) {
        grouped[line.id] = true;
      });
    });
    return items.every(function (item) {
      var hidden = item.el.classList.contains('is-pj-grouped-source');
      return grouped[item.id] ? hidden : !hidden;
    });
  }

  function apply() {
    var root = shadowRoot();
    if (!root) return;
    if (applying) {
      queued = true;
      return;
    }
    var section = root.querySelector('.upcart-products-section');
    if (!section) return;

    var nodes = Array.prototype.slice.call(section.querySelectorAll('.upcart-product-item'));
    var items = nodes.map(readItem);
    var groups = groupSets(items);
    if (renderedKey(section) === desiredKey(groups) && propertiesHidden(root) && sourcesMatch(items, groups)) return;

    applying = true;
    ensureStyle(root);

    var old = section.querySelectorAll('.PjUpcartGroup');
    for (var i = 0; i < old.length; i++) old[i].remove();
    for (var j = 0; j < nodes.length; j++) nodes[j].classList.remove('is-pj-grouped-source');

    hideInternalProperties(root);

    groups.forEach(function (group) {
      var card = buildGroup(group);
      group.lines[0].el.parentNode.insertBefore(card, group.lines[0].el);
    });

    applying = false;
    if (queued) {
      queued = false;
      schedule();
    }
  }

  function schedule() {
    if (applying) {
      queued = true;
      return;
    }
    window.requestAnimationFrame(apply);
  }

  function settle() {
    window.clearTimeout(settleTimer);
    var tries = 0;
    function check() {
      tries += 1;
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (response) {
        return response.json();
      }).then(function (cart) {
        var root = shadowRoot();
        var section = root && root.querySelector('.upcart-products-section');
        var count = section ? section.querySelectorAll('.upcart-product-item').length : -1;
        if (cart && count === cart.items.length) {
          apply();
          return;
        }
        if (tries < 20) settleTimer = window.setTimeout(check, 80);
      }).catch(function () {
        apply();
      });
    }
    check();
  }

  function bindCart() {
    if (cartBound || typeof window.upcartSubscribeCartUpdated !== 'function') return;
    cartBound = true;
    window.upcartSubscribeCartUpdated(function () {
      settle();
    });
    if (typeof window.upcartSubscribeCartOpened === 'function') {
      window.upcartSubscribeCartOpened(function () {
        settle();
      });
    }
  }

  function boot() {
    var root = shadowRoot();
    if (!root) return false;
    ensureStyle(root);
    if (!root.__pjSetCartObserver) {
      var observer = new MutationObserver(function () {
        schedule();
      });
      observer.observe(root, { childList: true, subtree: true });
      root.__pjSetCartObserver = observer;
    }
    bindCart();
    apply();
    return true;
  }

  var tries = 0;
  var timer = window.setInterval(function () {
    tries += 1;
    if (boot() || tries > 80) window.clearInterval(timer);
  }, 250);
})();
